import React from "react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

interface CustomAuditWildcardTooltipProps {
  children: React.ReactNode;
}

const wildcardRules = [
  {
    symbol: "%",
    title: "Multi-instance wildcard",
    description: "Matches repeating object instances in a path, such as indexed nodes.",
  },
  {
    symbol: ".",
    title: "Branch selector",
    description: "Targets a branch path so validation can match nested attributes under that branch.",
  },
];

const CustomAuditWildcardTooltip: React.FC<CustomAuditWildcardTooltipProps> = ({ children }) => {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          side="top"
          align="start"
          sideOffset={10}
          className="z-[2100] w-[300px] rounded-xl border border-border/80 bg-background/95 p-0 text-foreground shadow-[0_18px_40px_rgba(15,23,42,0.16)] backdrop-blur-sm"
        >
          <div className="overflow-hidden rounded-[inherit]">
            <div className="border-b border-border/70 bg-muted/60 px-4 py-3">
              <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">Custom Audit</p>
              <p className="mt-1 text-sm font-semibold text-foreground">Supported wildcards</p>
            </div>
            <div className="space-y-2 p-3">
              {wildcardRules.map((rule) => (
                <div key={rule.symbol} className="flex items-start gap-3 rounded-lg border border-border/60 bg-background px-3 py-2.5">
                  <span className="inline-flex h-7 min-w-7 items-center justify-center rounded-md border border-border bg-muted px-2 font-mono text-sm font-semibold text-foreground">
                    {rule.symbol}
                  </span>
                  <div className="min-w-0 space-y-0.5">
                    <p className="text-sm font-medium leading-5 text-foreground">{rule.title}</p>
                    <p className="text-xs leading-5 text-muted-foreground">{rule.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default CustomAuditWildcardTooltip;